//
//
//
//

export default {
  name: 'widget__mask',
  methods: {
    fireClick: function fireClick() {
      this.$emit('click');
    }
  }
};